import React, { useEffect, useState, useRef } from "react";
// import Swal from "sweetalert2";
import ConfirmationPopup from "../../../common/ConfirmationPopup"; 
import SuccessPopupMsg from "../../../common/Success-popup-msg"; 
import { deleteData,  postData, getData } from "../../../Service/ApiMethod"; 
import { useTranslation } from "react-i18next";
import {ADDTO_LIST, RECRUITER_PLAYLIST } from "../../../Service/service";
import { lang } from "../../../lang";


const AddToListRecomended = (props) => {
  const [ln,setLn] = useState('en')
  const [title, setTitle] = useState();
  const [addlist, setAddlist] = useState();
  const [deletePopup, setDeletePopup] = useState();
 const [titleId, setTitleId] = useState();
  const [playlist, setPlaylist] = useState();
  const [isError, setIsError] = useState();
  // const [list, setList] = useState();
  const [alertMessage,setAlertMessage] = useState(false);
  const [alertPopupMsg,setAlertPopupMsg] = useState();
  useEffect(()=>{
    if(localStorage.getItem("language") != null){
      setLn(localStorage.getItem("language"))
    }
  },[])
  const setclose = props?.closePopup || props?.setAddtolistPopupp || props?.setAddtolistPopup || props?.setPopup || props?.setAddtolistPop

  const applicantID = props?.seekerID

  console.log('applicantID', applicantID)

  const ref = useRef(null);
  useOutsideAlerter(ref);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setclose && setclose(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }


  const deleteTilte = () => {
    const obj = {
      id: titleId,
    };
    deleteData(obj, RECRUITER_PLAYLIST)
      .then((res) => res.json())
      .then((data) => setAlertPopupMsg(data?.message));
    setDeletePopup(false);
    getPlaylist();
  };

  const getPlaylist = () => {
    getData(RECRUITER_PLAYLIST)
      .then((response) => response.json())
      .then((data) => {
        setPlaylist(data.data);
      })
      .catch((err) => {
        console.log("Error in categories from Post Form", err);
        console.log(" code Error", err);
        setIsError(err.message);
        console.log(isError);
      });
  };


  console.log('playlist', playlist)

  const addPlaylist = async (listTitle) => {
    let objItem = {
      title: listTitle,
    };

    console.log("Static", objItem);
    if (title !== "") {
      await postData(objItem, RECRUITER_PLAYLIST)
        .then((response) => response.json())
        .then((data) => {
          try {
            if (data.error_message) {
              alert("Plese Fill All Fields");
            } else if (data.message) {
              // alert(data.message);
              alert(lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["You created a playlist successfully"]:"")
              getPlaylist();
            }
          } catch (err) {
            console.log("error hgappended", err);
          }
          setTitle("");
        });
      setAddlist(false);
    } else {
      alert("Title can't be blank");
    }
    // .catch(error => {
    //     console.log('show the error', error);
    // });
  };
  

  console.log(ADDTO_LIST, "thisss1")

  const postList = (applicantId, titleId) => {
    var result = window.confirm("Are you sure you want to proceed?");
    if(result){
      console.log(ADDTO_LIST, "thisss2")
      const obj = {
        applicant_id: props?.seekerID,
        title_id: titleId
      };
      console.log('obj',obj);
      postData(obj, ADDTO_LIST)
        .then((response) => response.json())
        .then((res) => {
          if(res?.error_message){
          // Swal.fire(res?.error_message)
          alert(res?.error_message)
          }else{
            console.log(res.data);
            console.log(res.message)
            // alert(res.message);
            setAlertPopupMsg(res?.message);
            // Swal.fire(res?.message)
            alert(res?.message)
          }
          // setList(res.data);
          // myFunction();
        })
        .catch((err) => {
          console.log("Error ", err);
          console.log(" code Error", err);
          // setTitle(err.message);
          // setAlertPopupMsg('oops someting is wrong')
          // alert(err.message)
        });
    }
   
  };
  useEffect(() => {
    // setList();
    getPlaylist()
  },[]);

  // useEffect(() => {
  // }, []);

  const {t} = useTranslation();
  
  return (
    <>
    <div className="blur-screen-full-area inner-modal  flex-center">
        <div className="add-to-list-box" ref={ref}>
          <div className="text-center"> 
            <p className="heading mt-2">{t('Add to a List')}</p> 
          </div>
          <div className="div my-3">
            <p className="text">
              <img className="send-job"
                src="../images/send-job.png"
                onClick={(e) =>{
                  // e.stopPropagation()
                  setAddlist(true)
                } }
             
                alt=""
                style={{ cursor: "pointer" }}
              />
              {t('Create New List')}
            </p>
          </div>
          {addlist ? (
       <div className="blur-screen-full-area inner-modal  flex-center">
              <div className="add-to-list-box relative" onClick={(e)=>e.stopPropagation()}>
                <span
                  className="text-danger"
                  onClick={(e) =>{
                  // e.stopPropagation()
                  setAddlist(false)
                  } }
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "10px",
                    cursor: "pointer",
                  }}
                >
                  {t('Close')}
                </span>
                <input
                  type="text"
                  placeholder={lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["Your Playlist Title"]:""} 
                  value={title}
                  onChange={(e) =>{
                    // e.stopPropagation()
                    setTitle(e.target.value)
                  } }
                  className=" form-control my-3"
                />

                <button
                  className="theme-btn w-100"
                  onClick={(e) =>{
                  // e.stopPropagation()
                    addPlaylist(title)
                  } }
                >
                  {t('Create')}
                </button>
              </div>
            </div>
          ) : null}

          {playlist !== undefined
            ? playlist?.map((item, i) => {
                return (
                  <div className="space-between d-flex my-2" key={i}>
                    <p className="text" style={{ width: "80%" }}>
                      {" "}
                      {item?.title}{" "}
                    </p>
                    <button
                      className="toggle-btn"
                      id={item?.id}
                      onClick={(e) => {
                        // e.stopPropagation()
                        console.log("ssssssssssss",item?.id)
                        setTitleId(item?.id);
                        postList(applicantID, item?.id);
                        setclose(false)
                        // setAlertMessage(true);
                      }}
                    >
                      {" "}
                      <img
                        src="../images/plus.png"
                        alt=""
                        // onClick={() => postData()}
                      />{" "}
                    </button>
                    {alertMessage ?<SuccessPopupMsg message={alertPopupMsg} closeAlert={setAlertMessage}/>:null}
                    {/* <button
                      className="toggle-btn"
                      id={item?.id}
                      onClick={(e) => {
                        e.stopPropagation()
                        setTitleId(item?.id);
                        setDeletePopup(true);
                      }}
                      style={{ width: "10%" }}
                    >
                      <img
                        src="../images/err.jpg"
                        style={{ height: "16px" }}
                        alt=""
                      />
                    </button> */}
                  </div>
                );
              })
            : null}

          <hr className="line" />

          {/* <button className="theme-btn w-100" onClick={props?.closePopup}> */}
          {/* <button className="theme-btn w-100" onClick={(e) => {
            e.stopPropagation()
            // props?.closePopup && props?.closePopup();
            // props?.setAddtolistPopup && props?.setAddtolistPopup(false)
            // props?.setAddtolistPopupp && props?.setAddtolistPopupp(false)
            setclose(false)
          }}>
            Done
          </button> */}
          {deletePopup ? (
          <ConfirmationPopup
            title="Are You Sure!"
            subTitle="You want to delete this Vaccancy?"
            handleNo={(e) =>{
              // e.stopPropagation()
              setDeletePopup(false)}}
            handleYes={() =>
              deleteTilte()}
          />
        ) : null}
        </div>
        
        {/* 
          <div className="space-between d-flex mb-2">
            <p className="text">Technicians For Flats</p>
            <button className="toggle-btn">
              <img src="./images/plus.png" alt="" />
            </button>
          </div>

          <hr className="line" />
          <div className="space-between d-flex mb-2">
            <p className="text">Driver for My Manager</p>

            <input type="checkbox" id="btnControl" />
            <button
              className="toggle-btn toggle-img-btn">
              <img
                src="./images/plus.png"
                className="toggle-img"
                alt=""
              />
            </button>
          </div>

          <hr className="line" />
          <div className="space-between d-flex mb-2">
            <p className="text">Nurses for Aditya Birla Hospital</p>
            <button className="toggle-btn">
              <img src="./images/plus.png" alt="" />
            </button>
          </div>

          <hr className="line" />
          <div className="space-between d-flex mb-2">
            <p className="text">Passout Year</p>
            <button className="toggle-btn">
              <img src="./images/plus.png" alt="" />
            </button>
          </div> */}
      </div>
    </>
  );
};

export default AddToListRecomended;
